import { render, staticRenderFns } from "./NavigationConfig.vue?vue&type=template&id=62369159&scoped=true"
import script from "./NavigationConfig.vue?vue&type=script&lang=js"
export * from "./NavigationConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62369159",
  null
  
)

export default component.exports